import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { corneliusConfig } from "./data";

export default function CorneliusPage() {
  return <CityPageTemplate config={corneliusConfig} />;
}